import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminPlayers } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const SearchSchema = z.object({
	tab: z.enum(["transferPlayers", "suggestions", "database"]).optional(),
});

export const Route = createFileRoute("/st-admin/transfer-players/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => (
		<DashboardLayout>
			<STAdminPlayers />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
